import { render, staticRenderFns } from "./TipoPagoPage.vue?vue&type=template&id=700eb27e"
import script from "./TipoPagoPage.js?vue&type=script&lang=js&external"
export * from "./TipoPagoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports